module.exports = __webpack_public_path__ + "static/media/ManSeatWithLaptop.fc1fdf90.png";